type getLabelProps = {
  step: number;
  totalSteps: number;
  isCarrierEnabled: boolean;
};

export function getLabel({ step, totalSteps, isCarrierEnabled }: getLabelProps) {
  return (step === totalSteps - 1 && !isCarrierEnabled) || (step === totalSteps && isCarrierEnabled)
    ? 'Recap'
    : `Avanti (step ${step + 2})`;
}
